import React from "react";
import { Grid, Popup } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import useFirestoreCollection from "../../../app/hooks/useFirestoreCollection";
import {
  listenToEmployerFreeJobsFromFirestore,
  listenToEmployerPaidJobsFromFirestore,
} from "../../../app/firestore/firestoreService";
import JobPostsList from "./JobPostsList";
import { JOB_POST_TYPE } from "../employerConstanst";
import CurrentJobPostsList from "./CurrentJobPostsList";
import {
  isItemExpired,
  isItemForApproval,
  isItemForListing,
} from "../../jobs/helpers/compareJobDates";
import questionMarkBlue from "../../../assets/icons/question-mark-blue.svg";
import {
  fetchEmployerFreeJobs,
  fetchEmployerPaidJobs,
} from "../employerActions";
import { QUERY_CODES } from "../../../app/firestore/firestoreConstants";
import {
  MANAGE_APPLICANTS_BUTTON,
  MANAGE_EDIT_BUTTON,
  MANAGE_VIEW_BUTTON,
  MANGE_REPOSTS_BUTTON,
} from "./JobPostListItem";

export function UnderReviewInfo({ responsive }) {
  return (
    <div style={{ marginTop: 10 }}>
      Under review
      <Popup
        content={
          <div className="popup-text">Excludes services awaiting payment</div>
        }
        position={responsive.isMobile ? "top left" : "top center"}
        on={"hover"}
        trigger={
          <img
            className="clickable"
            src={questionMarkBlue}
            style={{ width: 15, height: 15, marginLeft: 6 }}
            alt="question info"
          />
        }
      />
    </div>
  );
}

export default function ManageJobPosts({
  isAdmin = false,
  companyId = null,
  handleSetApplicantsView = () => {},
  handleSetStatsView = () => {},
}) {
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state.async);
  const { currentUserAccount } = useSelector((state) => state.account);
  const { jobs, draftJobs, freebies } = useSelector((state) => state.employer);
  const { responsive } = useSelector((state) => state.app);

  useFirestoreCollection({
    shouldExecute:
      currentUserAccount.id !== null && isAdmin && companyId !== null,
    query: () => listenToEmployerPaidJobsFromFirestore(companyId),
    data: (employerJobs) => dispatch(fetchEmployerPaidJobs(employerJobs)),
    deps: [dispatch, companyId],
    queryCode: QUERY_CODES.listenToEmployerPaidJobsFromFirestore,
  });

  useFirestoreCollection({
    shouldExecute:
      currentUserAccount.id !== null && isAdmin && companyId !== null,
    query: () => listenToEmployerFreeJobsFromFirestore(companyId),
    data: (employerJobs) => dispatch(fetchEmployerFreeJobs(employerJobs)),
    deps: [dispatch, companyId],
    queryCode: QUERY_CODES.listenToEmployerPaidJobsFromFirestore,
  });

  // useFirestoreCollection({
  //   shouldExecute: currentUserAccount.id !== null && isAdmin && companyId !== null,
  //   query: () => listenToEmployerDraftJobsFromFirestore(companyId),
  //   data: (draftJobs) => dispatch(fetchEmployerDraftJobs(draftJobs)),
  //   deps: [dispatch, currentUserAccount.id],
  //   queryCode: QUERY_CODES.listenToEmployerDraftJobsFromFirestore,
  // });

  const jobsToList = [...jobs, ...freebies.jobs];

  const expiredInfo = (
    <div style={{ marginTop: 10 }}>
      Expired
      <Popup
        content={
          <div className="popup-text">
            <div>
              Expired jobs marked as
              <span className="semi-bold"> "Pending" </span>
              are being processed by our team.
            </div>
            <div style={{ marginTop: 5 }}>
              Expired jobs marked as
              <span className="semi-bold"> "Closed" </span>
              have been processed.
            </div>
          </div>
        }
        position={responsive.isMobile ? "top left" : "top center"}
        on={"hover"}
        trigger={
          <img
            className="clickable"
            src={questionMarkBlue}
            style={{ width: 15, height: 15, marginLeft: 6 }}
            alt="question info"
          />
        }
      />
    </div>
  );

  return (
    <Grid>
      <Grid.Column computer={isAdmin ? 16 : 15} tablet={16} mobile={16}>
        <div className={"manage-items"}>
          {!isAdmin && (
            <div className="manage-items-heading-area">
              <h2>Manage Jobs</h2>
              <hr className="solid-divider" />
            </div>
          )}
          <JobPostsList
            jobs={draftJobs}
            heading="Draft"
            noJobsMessage="You have no draft jobs"
            deletable={true}
            editable={true}
            type={JOB_POST_TYPE.draft}
            loading={loading}
            mainButton={MANAGE_EDIT_BUTTON}
          />
          <JobPostsList
            jobs={jobsToList.filter((job) => isItemForApproval(job))}
            heading={<UnderReviewInfo responsive={responsive} />}
            noJobsMessage="You have no jobs under review"
            editable={true}
            type={JOB_POST_TYPE.underReview}
            isAdmin={isAdmin}
            preview={true}
            deletable={true}
            loading={loading}
            mainButton={MANAGE_VIEW_BUTTON}
            isShowMenu={true}
          />
          <CurrentJobPostsList
            jobs={jobsToList.filter((job) => isItemForListing(job))}
            heading={"Published"}
            noJobsMessage="You have no published jobs"
            type={JOB_POST_TYPE.current}
            isAdmin={isAdmin}
            applicants={true}
            handleSetApplicantsView={handleSetApplicantsView}
            handleSetStatsView={handleSetStatsView}
            loading={loading}
            stats={true}
            repost={true}
            mainButton={MANAGE_APPLICANTS_BUTTON}
          />
          <JobPostsList
            jobs={jobsToList.filter((job) => isItemExpired(job))}
            heading={expiredInfo}
            noJobsMessage="You have no expired jobs"
            editable={false}
            preview={true}
            applicants={true}
            handleSetApplicantsView={handleSetApplicantsView}
            handleSetStatsView={handleSetStatsView}
            hand
            repost={true}
            stats={true}
            type={JOB_POST_TYPE.expired}
            isAdmin={isAdmin}
            loading={loading}
            mainButton={MANGE_REPOSTS_BUTTON}
          />
        </div>
      </Grid.Column>
    </Grid>
  );
}
